import config from "@/config"
import http from "@/utils/request"

export default {
	getShopProductCategory:{
        url: `${config.API_URL}/bwmall/admin.decorate/getShopProductCategory`,
		name: "装修页面获取商品分类",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
	doDecorate:{
        url: `${config.API_URL}/bwmall/admin.decorate/doDecorate`,
		name: "装修模板",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
	article:{
        url: `${config.API_URL}/bwmall/admin/article/list/index`,
		name: "装修富文本获取",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
	getArticle:{
        url: `${config.API_URL}/bwmall/admin.decorate/getArticle`,
		name: "装修富文本id获取",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
	getShopProduct:{
        url: `${config.API_URL}/bwmall/admin.decorate/getShopProduct`,
		name: "装修页面获取商品",
		get: async function(params){
			return await http.get(this.url, params);
		}
    },
    publish:{
        url: `${config.API_URL}/bwmall/admin.decorate/publish`,
		name: "发布模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    down:{
        url: `${config.API_URL}/bwmall/admin.decorate/down`,
		name: "下架模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    doDecorateSave:{
        url: `${config.API_URL}/bwmall/admin.decorate/doDecorateSave`,
		name: "保存模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    preview:{
        url: `${config.API_URL}/bwmall/admin.decorate/preview`,
		name: "预览模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    saveDecorateImage:{
        url: `${config.API_URL}/bwmall/admin.decorate/saveDecorateImage`,
		name: "保存模板截图",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    edit:{
        url: `${config.API_URL}/bwmall/admin.decorate/edit`,
		name: "编辑模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    copy:{
        url: `${config.API_URL}/bwmall/admin.decorate/copy`,
		name: "复制模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    },
    destroy:{
        url: `${config.API_URL}/bwmall/admin.decorate/destroy`,
		name: "删除模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
    }
	
}
